require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/assign.js
 ** module id = 544
 ** module chunks = 0
 **/